

export enum GableType {
    None,
    Gable,
    SidePanel
}
